import { uid } from '../../../lib/uid';
import type { CashCatalogSlug } from '../cashCatalogTypes';

/*
  Plausible vocabulary rather than obviously synthetic values: none of these leaves `rsys_` or
  lands in the identity store, and an unreadable one would make the generated form worse at
  showing what the field is for. The rule is about where a value LANDS.
*/
const NAMES: Record<CashCatalogSlug, readonly string[]> = {
  'transaction-types': ['Cash Advance', 'Refunds', 'Utilities', 'Professional Fees', 'Travel Allowance'],
  'payment-types': ['Bank Transfer', 'Petty Cash', 'Manager’s Check', 'Online Banking'],
};

const DESCRIPTIONS: Record<CashCatalogSlug, string> = {
  'transaction-types': 'Sample transaction type. Delete it once the real vocabulary is in.',
  'payment-types': 'Sample payment type. Delete it once the real vocabulary is in.',
};

/**
 * A sample vocabulary row, so the form fills in one click.
 *
 * **Suffixed because the name is unique among active rows** and the create is idempotent on it —
 * without a suffix the second click would quietly return the first row.
 */
export function sampleCashCatalogEntry(catalog: CashCatalogSlug): { name: string; description: string } {
  const tag = uid().slice(0, 4).toUpperCase();
  const pool = NAMES[catalog];

  return {
    name: `${pool[Math.floor(Math.random() * pool.length)]} ${tag}`,
    description: DESCRIPTIONS[catalog],
  };
}
